<template lang="pug">
  v-dialog(v-model="show", persistent, max-width="50%")
    v-card
      v-card-title
        v-flex.md8.title Repasses
        v-flex.md4.text-xs-right
          v-btn(flat, @click="show = false;", density="comfortable", icon="", variant="plain")
            v-icon close
      v-card-text.pa-0
        repasses(ref="repasses")
</template>
  
<script>
import repasses from '@/pages/financeiro/repasse/Lista';

export default {
  components: {
    repasses,
  },
  data () {
    return {
      show : false
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
  },
  methods: {
    open(estabelecimento_id){
      const vm = this;
      vm.show = true;
      this.$refs.repasses.refresh(estabelecimento_id);
    },
    close(){
      const vm = this;
      vm.show = false;
    }
  }
}
</script>